import { inject } from '@vue/composition-api';import Vue from 'vue';
import { GlobalModal, ModalBase, spawn } from 'tv-modal';
export default (function (ctx, inject) {
  var modals = document.createElement('div'); // modals.classList.add()

  modals.setAttribute('id', 'modals');
  document.body.appendChild(modals);
  var ModalProgrammatic = {
    show: function show(props) {
      if (typeof props === 'string') props = {
        title: props
      };
      return spawn('modals', props, GlobalModal, Vue);
    }
  };
  inject('modal', ModalProgrammatic);
  Vue.component('ModalBase', ModalBase);
});